import { COOKIE_MORTGAGE_LEAD } from '@/constants/cookies';
import { getMortgageLead } from '@/graphql/queries/banking/mortgage';
import lang from '@/lang/middleware/products/mortgage';

export default async ({ $apolloQuery, app, $cookies, redirect, store }) => {
  const backHome = () => redirect(app.localePath('/compare-mortgages/'));
  const code = $cookies.get(COOKIE_MORTGAGE_LEAD);
  if (!code) return backHome();
  await $apolloQuery(getMortgageLead, { code }).then(lead => store.commit('order/set', lead)).catch(_ => backHome());
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('thank-you.description');
  const title = store.$i18n.t('thank-you.title');
  store.commit('pageContent/setHead', { description, title });
};
